'use client';

import { Suspense } from 'react';
import Image from 'next/image';
import Link from 'next/link';

// 提取useSearchParams逻辑到子组件
function ResultsContent() {
  const { useSearchParams } = require('next/navigation');
  const searchParams = useSearchParams();
  const score = searchParams.get('score');
  const imageUrl = searchParams.get('image');
  const message = searchParams.get('message');
  const details = searchParams.get('details');
  const tips = searchParams.get('tips');
  const age = searchParams.get('age');
  const height = searchParams.get('height');
  
  const getScoreColor = (score: number) => {
    if (score >= 9) return "text-purple-500";
    if (score >= 8) return "text-blue-500";
    if (score >= 7) return "text-green-500";
    if (score >= 6) return "text-yellow-500";
    return "text-gray-500";
  };

  return (
    <div className="max-w-4xl mx-auto pt-10">
      <h1 className="text-4xl md:text-6xl font-bold text-center text-gray-800 mb-8">
        Your Results
      </h1>

      <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8">
        {imageUrl && (
          <div className="relative w-64 h-64 mx-auto mb-8">
            <Image
              src={imageUrl}
              alt="Analyzed photo"
              fill
              className="object-cover rounded-lg"
            />
          </div>
        )}

        <div className="text-center">
          <div className={`text-7xl font-bold mb-4 ${score ? getScoreColor(parseFloat(score)) : 'text-gray-500'}`}>
            {score ? parseFloat(score).toFixed(1) : '0.0'}
          </div>
          
          {message && (
            <div className="text-xl text-gray-700 mb-4 px-4">
              {message}
            </div>
          )}

          {details && (
            <div className="text-lg text-gray-600 mb-4 px-4">
              {details}
            </div>
          )}

          {age && (
            <div className="text-lg text-gray-600 mb-4 px-4">
              Age: {age}
            </div>
          )}

          {height && (
            <div className="text-lg text-gray-600 mb-4 px-4">
              Height: {height}
            </div>
          )}

          {tips && (
            <div className="bg-blue-50 rounded-lg p-4 mb-6 text-gray-700">
              <h3 className="font-semibold mb-2">Tips:</h3>
              {tips}
            </div>
          )}

          <Link
            href="/"
            className="bg-blue-500 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-600 transition-colors inline-block"
          >
            Try Another Photo
          </Link>
        </div>
      </div>

      <div className="text-center text-gray-600 text-sm">
        <p>Remember: Beauty is subjective and this score is just for fun!</p>
        <p className="mt-2">Every person is unique and beautiful in their own way.</p>
      </div>
    </div>
  );
}

// 骨架屏组件
function ResultsSkeleton() {
  return (
    <div className="max-w-4xl mx-auto pt-10">
      <h1 className="text-4xl md:text-6xl font-bold text-center text-gray-800 mb-8">
        Your Results
      </h1>
      <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8">
        <div className="relative w-64 h-64 mx-auto mb-8 bg-gray-200 rounded-lg animate-pulse"></div>
        <div className="text-center">
          <div className="text-7xl font-bold mb-4 text-gray-300 animate-pulse">Loading...</div>
        </div>
      </div>
    </div>
  );
}

export default function ResultsClient() {

  return (
    <main className="min-h-screen bg-gradient-to-b from-blue-100 to-purple-100 p-4">
      <Suspense fallback={<ResultsSkeleton />}>
        <ResultsContent />
      </Suspense>
    </main>
  );
} 